import { useInfiniteQuery } from '@tanstack/react-query'
import { getProductList } from 'lib/api/motishop/getProductList'

const useGetProductListInfiniteQuery = ({ lastPosNo, limit }, options) => {
  return useInfiniteQuery(
    createKey(lastPosNo, limit),
    ({ pageParam }) => getProductList({ lastPosNo: pageParam, limit }),
    {
      getNextPageParam: (productList) => {
        const { products } = productList.data
        return products.length === 20 ? products.at(-1).no : undefined
      },
      ...options,
    },
  )
}

const createKey = (lastPosNo, limit) => ['motishop-product', lastPosNo, limit]
export default useGetProductListInfiniteQuery
